import React, {useEffect} from 'react';
import {Col, Row} from 'reactstrap';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";

// components
import { showLoader} from "../../../components/loader/loader";
import MenuList from "./_list";

// actions
import {
    setForm,
    setItem,
    ADD_STATE,
    REMOVE_STATE,
} from "../../../redux/actions/generics/IndexedActions";



function Menu(props) {
    const path = props.path || 'ui/menu';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    {componentState && <MenuList path={path}/>}
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = _ => ({});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setForm,
    setItem
});

export default connect(mapStateToProps, mapActionsToProps)(Menu)

